module.exports = __webpack_public_path__ + "static/media/ABC Reading Club.8bde7432.jpeg";